"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** Filters a GeneralCatalogItem for renderConditions
 *
 * @param arrayToFilter - Endpoint's all items in array.
 * @param arrayToMatch -
 * @returns
 */
var filterGeneralCatalog = function (arrayToFilter, arrayToMatch) {
    if (arrayToMatch) {
        return arrayToFilter.filter(function (item) { return arrayToMatch.includes(item.code); });
    }
    return arrayToFilter;
};
exports.default = filterGeneralCatalog;
//# sourceMappingURL=filterGeneralCatalog.js.map